'use strict';
const { createAddQueries } = require('../addQueries');
const {
  id,
  payerId,
  userId,
  modelId,
} = require('./commons');

module.exports = createAddQueries({
  returnModel: {
    name: 'userModel',
  },
  finders: [
    id,
    payerId,
    userId,
    modelId,
  ],
  orderBy: [
    id,
    payerId,
    userId,
    modelId,
  ],
});
